<template>
    <div class=" mt-3">
        <div class="col-12">
            <div class="row">

                <div class="col-2 float-left form-group">
                    <button class="btn btn-primary">
                        <router-link :to="{name:'index'}" class="text-white"> بازگشت</router-link>
                    </button>
                </div>
            </div>
        </div>
        <div class="">
            <div id="col-12" style="position: static">
                <div class="card soft-shadow mt-3 order-border" v-for="entry in entries" :key="entry.id">
                    <div class="card-header" :id="'heading'+entry.id">
                        <h5 class="mb-0">
                            <div class="row text-center d-flex justify-content-center">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-6 text-primary font-weight-bold"><span>{{entry['1.3']}}</span>
                                        </div>
                                        <div class="col-6"><span>{{entry['date_created']}}</span></div>
                                    </div>
                                </div>
                                <div class="col-12 mt-2">
                                    <div class="row">
                                        <div class="col-12">{{entry['4']}}</div>
                                        <hr class="col-12">
                                        <div class="col-12 mt-2 text-right"><p style="font-size: 1rem">
                                            {{entry['3']}}</p></div>
                                        <div class="col-4 mt-3">
                                            <div class="btn btn-danger" @click="deleteEntry(entry['id'])">حذف</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </h5>
                    </div>
                </div>

            </div>
        </div>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // import Paginate from 'vuejs-paginate'
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "Major",

        data() {
            return {
                entries: [],
                count: 0,
                lastPage: 0,
                isLoading: true,
                fullPage: true,
                counter: 0
            }
        },
        components: {
            Loading,
        },
        mounted() {

            //check what was the last city and page

            this.checkToken();
            this.getOrders();
        },
        methods: {
            checkToken: function () {
                let token = localStorage.getItem('token');

                if (token === null) {
                    this.$router.push({
                        name: "login"
                    })
                }

                this.axios.get(this.$hostname + "token", this.$header).then(response => {

                    if (!response.data.success) {
                        this.$router.push({
                            name: "login"
                        })
                    }

                }).catch(() => {
                    this.$router.push({
                        name: "login"
                    })
                })
            },
            deleteEntry: function (id) {
                this.$swal({
                    title: 'آیا میخواهید خارج شوید؟',
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: `بله`,
                    cancelButtonText: `بازگشت`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {

                        this.isLoading = true;
                        let url = 'https://pay.farskala.ir/wp-json/gf/v2/entries/' + id;


                        this.axios.delete(url, {
                            headers: {
                                'Authorization': 'Basic Y2tfMmMzZThhOTZhYmUxY2VkZjgxYTVkODJkNGNhZGRkM2I4NTJhNGNmMDpjc19hMjFlN2MxYzk1ZTUxZDVhYzkxMWFjYTdmMGQxYWIzYjQ5ZTIwODg4'
                            }
                        }).then(() => {
                            this.isLoading = false;
                            document.getElementById("heading" + id).parentNode.classList.add("d-none");

                        }).catch(error => {
                            console.log(error.response);
                        });

                    }
                });
            },
            getOrders: function () {

                this.isLoading = true;

                let url = 'https://pay.farskala.ir/wp-json/gf/v2/entries?form_ids[0]=4&paging[page_size]=100000&_field_ids=id,1.3,4,3, date_created';


                this.axios.get(url, {
                    headers: {
                        'Authorization': 'Basic Y2tfMmMzZThhOTZhYmUxY2VkZjgxYTVkODJkNGNhZGRkM2I4NTJhNGNmMDpjc19hMjFlN2MxYzk1ZTUxZDVhYzkxMWFjYTdmMGQxYWIzYjQ5ZTIwODg4'
                    }
                }).then(response => {
                    this.isLoading = false;
                    this.entries = response.data.entries;
                }).catch(error => {
                    alert(error);
                });

                // let Data = {
                //     city: this.city,
                //     page: this.page,
                //     search: this.search,
                //     status: this.status
                // };
                //
                // this.axios.post(this.$hostname + "orders", Data, this.$header).then(response => {
                //     this.orders = response.data.data.orders;
                //     this.count = response.data.data.count;
                //     this.lastPage = response.data.data.last_page;
                //     this.statuses = response.data.data.statuses;
                //     this.sender = response.data.data.sender;
                //
                //     this.isLoading = false;
                //
                // }).catch(error => {
                //     this.isLoading = false
                //     alert(error.response);
                // });
            },
        }
    }
</script>

<style scoped>
    .btn-link {
        color: #000000;
    }

    .btn-link.focus, .btn-link:focus {
        text-decoration: none;
    }

    .btn.focus, .btn:focus {
        box-shadow: none;
    }

    .btn:hover {
        text-decoration: none;
    }

    .accordion div {
        position: static;
    }

    .card {
        background-color: #fff;
    }

    #accordion h5 {
        font-size: 1rem;
    }

    .products {
        padding-bottom: 5px;
        padding-top: 6px;
        border-bottom: 1px solid rgba(86, 86, 86, 0.15);
    }

    .order-note {
        border-radius: 10px;
        background-color: #BDF9C9;
        color: #000000;
        padding: 10px;
        font-size: .7rem;
        text-align: right;
        margin-bottom: 5px;
    }


</style>